// A referral link (/?ref=CODE) usually lands on the homepage, and the visitor may
// browse for a while before signing up, so the code is kept in localStorage until
// the signup form picks it up.

const KEY = 'tep:referralCode';
// Optional channel tag on affiliate links (?ref=CODE&src=youtube)
const SOURCE_KEY = 'tep:referralSource';
const CLICK_KEY = 'tep:referralClicks';

export const cleanReferralCode = (raw) =>
  String(raw || '').toUpperCase().replace(/[^A-Z0-9-]/g, '').slice(0, 20);

export const cleanReferralSource = (raw) =>
  String(raw || '').toLowerCase().replace(/[^a-z0-9_-]/g, '').slice(0, 30);

export const saveReferralCode = (raw, rawSource) => {
  const code = cleanReferralCode(raw);
  if (!code) return;
  try {
    localStorage.setItem(KEY, code);
    // A new link replaces the old one's channel too
    const source = cleanReferralSource(rawSource);
    if (source) localStorage.setItem(SOURCE_KEY, source);
    else localStorage.removeItem(SOURCE_KEY);
  } catch {
    // Storage disabled: the code still works if they sign up from the same URL
  }
};

export const getReferralCode = () => {
  try {
    return localStorage.getItem(KEY) || '';
  } catch {
    return '';
  }
};

export const getReferralSource = () => {
  try {
    return localStorage.getItem(SOURCE_KEY) || '';
  } catch {
    return '';
  }
};

// Affiliate click counts: once per browser per link per day, so refreshes and
// browsing back to the homepage don't inflate them
export const isNewReferralClick = (code, source) => {
  const key = `${cleanReferralCode(code)}|${cleanReferralSource(source)}|${new Date().toISOString().slice(0, 10)}`;
  try {
    const seen = JSON.parse(localStorage.getItem(CLICK_KEY) || '[]');
    if (seen.includes(key)) return false;
    localStorage.setItem(CLICK_KEY, JSON.stringify([...seen.slice(-19), key]));
  } catch {
    // Storage disabled: count it
  }
  return true;
};

export const clearReferralCode = () => {
  try {
    localStorage.removeItem(KEY);
    localStorage.removeItem(SOURCE_KEY);
  } catch {
    // ignore
  }
};
